import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaSearch, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import buildLink from "../../../../urls";
import axios from "axios";
import hocStarredPage from "../../../../components/hocStarredPage";
import { PlaySounds } from "../../../../functions/playSounds";
import MessageAlert from "../../../../components/messageAlert";
import PointsLoader from "../../../../components/PointsLoader";
import { axiosServer } from "../../../../axiosServer";

const Pickupfloorv2 = () => {
  const [message, setMessage] = useState("");
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const history = useNavigate();
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const floorID = useRef(null);
  const [floors, setFloors] = useState([]);
  const [loadingFloors, setLoadingFloors] = useState(true);
  const [processingFloor, setProcessingFloor] = useState(false);

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  useEffect(() => {
    floorID.current.focus();
    const fetch_floor = async () => {
      const userID = getUserIdFromLocalStorage();

      setLoadingFloors(true);
      try {
        const url = buildLink("getFloors") + userID;
        const response = await axiosServer.get(url);
        if (response.data.success) {
          const floorsData = response.data.data.order_floors || [];
          setFloors(floorsData);
        }
      } catch (e) {
        console.log("Error fetching floors:", e);
        setMessage("Failed to load floors");
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 5000);
      } finally {
        setLoadingFloors(false);
      }
    };
    fetch_floor();
  }, []);

  async function getFloorProduct(e) {
    e.preventDefault();
    if (floorID.current.value.trim() === "") {
      setMessage("Please enter a Floor ID");
      setShowMessageErr(true);
      playErrorSound();
      setTimeout(() => setShowMessageErr(false), 5000);
      return;
    }

    const enteredFloorId = floorID.current.value.trim();
    const selectedFloor = floors.find(
      (floor) =>
        floor.floor_id === enteredFloorId ||
        floor.floor_name === enteredFloorId ||
        floor.floor_id === parseInt(enteredFloorId, 10)
    );

    if (!selectedFloor) {
      setMessage("Floor ID not found. Please enter a valid Floor ID.");
      setShowMessageErr(true);
      playErrorSound();
      setTimeout(() => setShowMessageErr(false), 5000);
      return;
    }

    const userID = getUserIdFromLocalStorage();

    try {
      setProcessingFloor(true);
      playSuccessSound();

      // Save request info to localStorage for later use in scanPickUpFloor
      const requestInfo = {
        userID,
        floor_id: selectedFloor.floor_id,
        orders_quantity: selectedFloor.orders_quantity,
        returns_quantity: selectedFloor.returns_quantity,
        enteredFloorId,
      };
      localStorage.setItem("pickupFloorRequestInfo", JSON.stringify(requestInfo));

      // redirect to scanPickUpFloor (scanPickUpFloor will handle the requests)
      history(`${enteredFloorId}/scanpickupfloor`, {
        state: {},
      });
    } catch (error) {
      console.error("Error processing floor:", error);
      setMessage("Something went wrong while processing the floor.");
      setShowMessageErr(true);
      playErrorSound();
      setTimeout(() => setShowMessageErr(false), 5000);
    } finally {
      setProcessingFloor(false);
    }
  }

  const handleTrashClick = () => {
    floorID.current.value = "";
    floorID.current.focus();
  };

  return (
    <>
      <div className=" h-full bg-white">
        {/* header */}
        <div className=" mb-5 sticky top-0 flex flex-col bg-white z-50">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl my-auto">Pick Up Floor</h2>
            </div>
          </div>
        </div>

        <div className=" container">
          <form className=" flex flex-col" onSubmit={(e) => getFloorProduct(e)}>
            <div className="container flex flex-row justify-center items-end gap-3 ">
              <div className="relative flex-1">
                <div className="mb-1">Floor ID</div>
                <input
                  ref={floorID}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Floor ID"
                />
                <div>
                  <FaTrash
                    onClick={() => handleTrashClick()}
                    className="absolute top-[55px] transform -translate-y-1/2 right-3 cursor-pointer opacity-20  "
                  />
                </div>
              </div>
              <button
                className=" bg-dbase rounded-md text-white px-5  h-12"
                disabled={processingFloor}
              >
                <FaSearch />
              </button>
            </div>
          </form>
        </div>

        {/* Floors Display Section */}
        <div className="container mb-6">
          {loadingFloors ? (
            <div className="flex justify-center items-center py-8">
              <PointsLoader />
            </div>
          ) : (
            <div className="space-y-2 p-3">
              {floors.map((floor) => (
                <div
                  key={floor.floor_id}
                  className="border border-dgrey1 rounded p-3 cursor-pointer"
                >
                  <div className="text-lg text-dblack font-semibold">
                    <span>{floor.floor_name ? floor.floor_name : `Floor ${floor.floor_number}`}</span>
                    {floor.to_pick_quantity !== undefined && (
                      <span>
                        {" - "}To Pick: {floor.to_pick_quantity}
                      </span>
                    )}
                  </div>
                  {floor?.warehouse_name && (
                    <div className="text-sm text-gray-500">
                      <span className="font-medium text-dblack">Warehouse Name:</span>{" "}
                      {floor.warehouse_name}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>


        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default hocStarredPage(Pickupfloorv2);
